import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { axiosInstance } from './axiosInstance';

import { HttpHandler } from '../../http/HttpHandler';
import { Request } from '../../http/Request';
import { Response } from '../../http/Response';

function transformToAxiosRequest({
  method,
  url,
  headers,
  body,
  cancelToken
}: Request): AxiosRequestConfig {
  return { method, url, headers, data: body, cancelToken, responseType: 'blob' };
}

function transformToStandardResponse(response: AxiosResponse): Response {
  return {
    status: response.status,
    headers: response.headers,
    body: response.data
  };
}

export const axiosHttpHandler: HttpHandler = (request) => {
  return axiosInstance.request(transformToAxiosRequest(request)).then(transformToStandardResponse);
};
